import React from 'react'
import { useCompanyLogoQuery } from './CompanyLogo.generated-types'

export const CompanyLogo: React.FC = (): JSX.Element => {
  const [{ data }] = useCompanyLogoQuery({
    requestPolicy: 'cache-and-network'
  })

  if (data?.me?.companyLogoUrl) {
    return (
      <img src={data.me.companyLogoUrl + '?fm=jpg&h=192&dpr=3&auto=compress&q=30'} width={70} />
    )
  }

  return <></>
}
